import DOMPurify from 'dompurify'

import { 
    clone,
    truncate
} from 'lodash'

import {
    stringIsEmpty
} from 'utils'

export const splitCamelcaseText = text => {
    if(!text){
        return ''
    }
    
    const splitText = text.replace(/([a-z](?=[A-Z]))/g, '$1 ')
    const capitalise = splitText.charAt(0).toUpperCase() + splitText.slice(1);
    return capitalise;
}

export const safelyFormatText = text => {
    let newText = clone(text)

    const termsToKeep = [
        'script',
        'link',
        'meta',
    ]

    termsToKeep.forEach(term => {
        let termUpperCase = term.toUpperCase()
        let regex = new RegExp('<' + term, 'g')
        let capsRegex = new RegExp('<' + termUpperCase, 'g')

        newText = newText.replace(regex, '&lt;' + term)
        newText = newText.replace(capsRegex, '&lt;' + termUpperCase)
    })

    newText = DOMPurify.sanitize(newText)

    return newText
}

export const paragraphToLines = paragraph => {
    const lineArray = []

    if (paragraph) {
        const tempLineArray = paragraph.replace(/(<([^>]+)>)/ig, '\n').replace('&nbsp;', '').split('\n')

        tempLineArray.forEach(line => {
            if(!stringIsEmpty(line) && line !== '@'){
                lineArray.push(line)
            }
        })
    }

    return lineArray
}

export const nl2br = text => {
    text = text.replace(/(?:\r\n|\r|\n)/g, '<br />')

    return text
}

export const stripHtml = str => {
    return str.replace(/(<([^>]+)>)/ig, '').replace('\n', '').replace('&nbsp;', '');
}

export const getMentionIdsFromComment = comment => {
    const mentionIds = []

    let rawMentionIds

    if (comment.includes('denotation')) {
        rawMentionIds = comment.match(/data-id="([^"]*")/g)

        if (rawMentionIds) {
            rawMentionIds.forEach(rawMention => {
                const mentionId = rawMention.replace(/data-id=/g, '').replace(/"/g, '')

                mentionIds.push(parseInt(mentionId))
            })
        }
    } else {
        rawMentionIds = comment.match(/#mention-([^"]*")/g);

        if (rawMentionIds) {
            rawMentionIds.forEach(mention => {
                let thisMention = parseInt(mention.replace('#mention-', '').replace('"', ''));

                if (mentionIds.indexOf(thisMention) == -1) {
                    mentionIds.push(thisMention);
                }
            })
        }
    }

    return mentionIds
}


export const getUrlParams = (name, url) => {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
}


export const getCaretPosition = ctrl => {
    // IE < 9 Support
    if (document.selection) {
        ctrl.focus();
        var range = document.selection.createRange();
        var rangelen = range.text.length;
        range.moveStart('character', -ctrl.value.length);
        var start = range.text.length - rangelen;
        return { 'start': start, 'end': start + rangelen };
    }
    // IE >=9 and other browsers
    else if (ctrl.selectionStart || ctrl.selectionStart == '0') {
        return { 'start': ctrl.selectionStart, 'end': ctrl.selectionEnd };
    } else {
        return { 'start': 0, 'end': 0 };
    }
}

export const numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const ucfirst = string => {
    if(!string){
        return ''
    }

    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getBaseSlugFromPath = path => {
    return '/' + (path.replace('/', '').split('/')[0])
}

export const processNotificationList = (notificationIds, entities) => {
    const truncateLength = 220
    const notificationsList = []

    notificationIds.forEach(notificationId => {
        let canOpen = true
        const notificationObject = entities.notifications[notificationId]

        const account = entities.accounts[notificationObject.account_id]

        let shouldPush = true
        let notifyable = null
        let instigatorName = null

        let instigator = entities.users[notificationObject.instigator_id]

        if (instigator) {
            instigatorName = instigator.first_name + ' ' + instigator.last_name
        } else if(notificationObject.instigator_name){
            instigatorName = notificationObject.instigator_name
        } else {
            instigatorName = 'A deleted user'
        }

        let notificationText = '<strong>' + instigatorName + '</strong> '

        // backslashes are troublesome in js
        const escapedTypeString = notificationObject.notifyable_type.replace('App\\', '').toLowerCase()

        // remember, this is doubled up in the notification mailer on the API.
        if (entities[escapedTypeString + 's'] && entities[escapedTypeString + 's'][notificationObject.notifyable_id]) {
            switch (escapedTypeString) {
                case 'task':
                    notifyable = entities.tasks[notificationObject.notifyable_id]

                    if (!notifyable || !notifyable.name) {
                        shouldPush = false
                        return
                    }

                    const taskName = '<strong>"' + truncate(notifyable.name, truncateLength) + '"</strong>'

                    switch (notificationObject.action) {
                        case 'ADD':
                            notificationText += 'added you to the task ' + taskName + '.'
                            break
                        case 'SUBSCRIBED_PROJECT_TASK_CHANGE_STATUS':
                            notificationText += 'changed the status of ' + taskName + '.'
                            break
                        case 'SUBSCRIBED_PROJECT_TASK_CHANGE_ENDDATE':
                            notificationText += 'changed the date of ' + taskName + '.'
                            break
                        case 'SUBSCRIBED_PROJECT_TASK_CHANGE_USERS':
                            notificationText += `changed users on ${taskName}.`
                            break
                        case 'SUBSCRIBED_PROJECT_TASK_RENAME':
                            notificationText += `renamed the task ${taskName}`
                            break
                        case 'UPLOAD':
                            notificationText += `uploaded ${(notificationObject.dupe_count && notificationObject.dupe_count > 1) ? notificationObject.dupe_count + ' files' : 'a file'} to the task ${taskName}`
                            break
                        case 'START':
                            notificationText = `${ taskName } ${ notificationObject.dupe_count ? `and ${ notificationObject.dupe_count } other task${ notificationObject.dupe_count > 1 ? 's' : ''} ` : '' } ${ notificationObject.dupe_count > 1 ? 'are' : 'is' } due to start today`
                            break
                        case 'ADD_QUICK_TASK':
                            notificationText += `set ${ taskName } as a <strong>'Quick Task'</strong>`
                            break
                    }
                    break
                case 'milestone':
                    notifyable = entities.milestones[notificationObject.notifyable_id]

                    if(!notifyable || !notifyable.name){
                        return shouldPush = false
                    }

                    const milestoneName = `<strong>${ notifyable.name }</strong>`

                    switch(notificationObject.action){
                        case 'SUBSCRIBE_NEW_MILESTONE':
                            notificationText += `added the milestone <strong>${milestoneName}</strong> to a project you're subscribed to.`
                            break
                    }
                    break
                case 'comment':
                    let commentObject = entities.comments[notificationObject.notifyable_id];
                    notifyable = entities.tasks[commentObject.task_id]

                    if (!notifyable) {
                        notifyable = notificationObject.notifyableParent
                    }

                    if (!notifyable || !notifyable.name) {
                        shouldPush = false
                        return
                    }

                    switch (notificationObject.action) {
                        case 'REPLY':
                            notificationText += 'replied to your comment on <strong>"' + truncate(notifyable.name, truncateLength) + '"</strong>'
                            break
                        case 'COMMENT':
                            notificationText += 'also commented on the task <strong>"' + truncate(notifyable.name, truncateLength) + '"</strong>'
                            break
                        case 'MENTION':
                            notificationText += 'mentioned you in the task <strong>"' + truncate(notifyable.name, truncateLength) + '"</strong>'
                            break
                        case 'POSTED_COMMENT_LIKED':
                            notificationText += 'liked your comment <strong>"' + truncate(stripHtml(commentObject.text), truncateLength) + '"</strong>'
                            break
                        case 'LIKED_COMMENT_LIKED':
                            notificationText += 'also liked the comment <strong>"' + truncate(stripHtml(commentObject.text), truncateLength) + '"</strong>'
                            break
                        case 'SUBSCRIBED_PROJECT_COMMENT':
                            notificationText += 'commented on <strong>"' + truncate(notifyable.name, truncateLength) + '"</strong>'
                            break
                    }
                    break
                case 'project':
                    notifyable = entities.projects[notificationObject.notifyable_id]
                    const target = notificationObject.target ? entities[notificationObject.target.schema][notificationObject.target_id] : null

                    if (!notifyable) {
                        shouldPush = false
                        return
                    }

                    switch (notificationObject.action) {
                        case 'SUBSCRIBE':
                            notificationText += 'subscribed you to the project <strong>"' + truncate(stripHtml(notifyable.name), truncateLength) + '"</strong>';
                            break
                        case "TEAM_ADDED_TO_PROJECT":
                            if (target) {
                                notificationText += `added your team ${target ? `'<strong>${target.name}</strong>'` : ''} to <strong>${notifyable.name}</strong>`
                            } else {
                                notificationText += `added a since-deleted team to <strong>${notifyable.name}</strong>`
                            }
                            break
                        case "GUEST_ADDED_TO_PROJECT":
                            notificationText += `added you to the project <strong>${notifyable.name}</strong>`
                            break
                        case 'INVITE':
                            notificationText += `invited you to the project <strong>${notifyable.name}</strong>`
                            break

                    }

                    break
                case 'note':
                    notifyable = entities.notes[notificationObject.notifyable_id]

                    if (!notifyable) {
                        shouldPush = false
                        return
                    }

                    let title = null

                    if(notifyable.name){
                        title = notifyable.name
                    }else{
                        let allLines = paragraphToLines(notifyable.text)

                        allLines.forEach(line => {
                            if (line && !title) {
                                title = line
                            }
                        })
                    }

                    if (title) {
                        switch (notificationObject.action) {
                            case 'MENTION':
                                notificationText += 'mentioned you in the note <strong>"' + truncate(stripHtml(title), truncateLength) + '"</strong>';
                                break
                        }
                    }

                    break
                case 'invitation':
                    canOpen = false

                    switch (notificationObject.action) {
                        case 'INVITATION_ACCEPTED':
                            notificationText += 'has accepted your invitation'
                            break
                    }

                    break
                case 'team':
                    canOpen = false
                    const teamObject = entities.teams[notificationObject.notifyable_id]

                    switch (notificationObject.action) {
                        case 'ADD':
                            notificationText += 'added you to the team <strong>' + teamObject.name + '</strong>'
                            break
                        case 'ADD_ADMIN':
                            notificationText += 'added you as an admin to the team <strong>' + teamObject.name + '</strong>'
                            break
                        case 'ADMIN':
                            notificationText += 'assigned you as an admin to the team <strong>' + teamObject.name + '</strong>'
                            break
                    }
                    break
                case 'account':
                    canOpen = false

                    switch (notificationObject.action) {
                        case 'UPGRADE':
                            notificationText = "Your Hassl account has been activated! Take a look around."
                            instigator = null
                            break
                        case 'DOWNGRADE':
                            notificationText += `has downgraded your organization to <strong>Standard</strong>.`
                            break
                        case 'RESUME':
                            notificationText += `has resumed your subscription to <strong>Hassl</strong>.`
                            break
                        case 'ROLE_SET_ADMIN':
                            notificationText += 'has assigned you to <strong>administrator</strong>.'
                            break
                        case 'ROLE_SET_PM':
                            notificationText += 'has assigned you to <strong>project manager</strong>.'
                            break
                    }
                    break
                case 'bulletin':
                    notificationText += 'has posted an announcement'
                    break
                case 'event':
                    const eventObject = entities.events[notificationObject.notifyable_id]

                    notificationText += 'has added a new calendar event "<strong>' + eventObject.title + '</strong>"'
                    break
            }
        } else {
            shouldPush = false
        }

        if (notificationText && shouldPush) {
            notificationsList.push({
                object: notificationObject,
                account,
                text: notificationText,
                instigator,
                notifyable,
                type: escapedTypeString,
                canOpen
            })
        }
    })

    return notificationsList
}

export const getHeadingLabels = (columns, hasFeature) => {
    const labels = []

    columns && columns.forEach(column => {
        const object = {}

        switch(column.type){
            case 'PROJECT':
                object.className = 'task-project'
                object.title = 'Project'
                break
            case 'PEOPLE':
                object.className = 'task-people'
                object.title = 'People'
                break
            case 'STATUS':
                object.className = 'task-status'
                object.title = 'Status'
                break
            case 'DATE':
                object.className = 'task-dates'
                object.title = 'Dates'

                if(!hasFeature('gantts') || !column.is_primary){
                    object.className = 'task-dates single'
                    object.title = 'Due date'
                }
                break
            case 'TEXT':
            case 'LINK':
                object.className = 'task-text'
                object.title = column.type === 'LINK' ? 'Link' : 'Text'
        }

        if(column.custom_name){
            object.title = column.custom_name
        }

        return labels.push(object)
    })

    if(hasFeature('timing')){
        labels.push({
            title: 'Timing',
            className: 'task-timing less-padding-left'
        })
    }

    return labels
}

export const doDirtyInput = (operation, id) => {
    if(!window.dirtyInputs){
        return
    }

    if(operation == 'add' && !window.dirtyInputs.includes(id)){
        window.dirtyInputs.push(id)
    }else if(operation == 'remove' && window.dirtyInputs.includes(id)){
        const commentDirtyInputIndex = window.dirtyInputs.indexOf(id)

        window.dirtyInputs.splice(commentDirtyInputIndex, 1)
    }
}


// WEBPACK FOOTER //
// ./src/utils/text.js